const config = {
  get VECTOR_AI_URL() {
    return process.env.VECTOR_AI_URL ?? "https://api.vctr.ai";
  },
  get DEBUG() {
    return process.env.NODE_ENV !== "production";
  },
  get VECTOR_AI_LOGO() {
    return "https://getvectorai.com/assets/logo-square.png";
  },
  get VECTOR_AI_LOGO_WITH_TEXT() {
    return "https://getvectorai.com/assets/logo-with-text.png";
  },
};

export default config;
